import { Component, inject, signal } from '@angular/core';
import { MatIcon } from '../../components/mat-icon/mat-icon';
import { InternalToolbar } from '../../components/internal-toolbar/internal-toolbar';
import { ReactiveIconTextButton } from '../../components/reactive-icon-text-button/reactive-icon-text-button';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SkeletonModule } from 'primeng/skeleton';
import { ButtonModule } from 'primeng/button';
import { TAGUser } from '../../../models/taguser';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../api.service';
import { DialogService } from 'primeng/dynamicdialog';
import { dialogConfig } from '../../dialogs';
import { UserEditDialog, UserEditDialogData } from './userEditDialog';

@Component({
  selector: 'app-internal-users',
  imports: [
    MatIcon,
    InternalToolbar,
    ReactiveIconTextButton,
    TableModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    TranslatePipe,
    SkeletonModule,
    ButtonModule,
  ],
  providers: [DialogService, TranslateService],
  templateUrl: './internal-users.html',
  styleUrl: './internal-users.scss',
})
export class InternalUsers {
  private dialogService = inject(DialogService);
  private translate = inject(TranslateService);
  private messageService = inject(MessageService);
  //private router = inject(Router);
  //private route = inject(ActivatedRoute);
  public api = inject(ApiService);

  users = signal<TAGUser[]>([]);
  loading = signal(true);

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    this.loading.set(true);
    this.users.set(Array.from({ length: 3 }).map((_, i) => new TAGUser()));

    this.api
      .getUsers()
      .then((users: TAGUser[]) => {
        let neUsers = users.sort((a, b) => a.registerdate.getTime() - b.registerdate.getTime());

        this.users.set(neUsers);
        this.loading.set(false);
      })
      .catch((reason) => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.translate('errors.couldNotLoadUsers')(),
          detail: reason.message,
        });
      });
  }

  editUser(user?: TAGUser) {
    const dialogRef = this.dialogService.open(
      UserEditDialog,
      dialogConfig<UserEditDialogData>({
        data: {
          user: user,
        },
      }),
    );

    dialogRef.onClose.subscribe((result) => {
      console.log(result);
      if (result) {
        this.loadUsers();
      }
    });
  }
}
